/* tslint:disable:no-any */
import 'reflect-metadata';
import { getMetaMissingFunctionsErrorMsg } from './errorMessages';
import { MethodMeta } from './MethodMeta';

export const META_KEY_SERVICE = 'service';

export class ServiceMeta {
  public static get(target: object): ServiceMeta {
    return Reflect.getMetadata(META_KEY_SERVICE, target);
  }

  public static getOrCreate(target: object): ServiceMeta {
    if (!Reflect.hasMetadata(META_KEY_SERVICE, target)) {
      Reflect.defineMetadata(META_KEY_SERVICE, new ServiceMeta(), target);
    }
    return this.get(target);
  }

  public static getOrThrow(target: object, error: string | (() => any)): ServiceMeta {
    const result = this.get(target);
    if (!result) {
      const err = typeof error === 'string' ? error : error();
      throw typeof err === 'string' ? new Error(err) : err;
    }

    return result;
  }

  public domain: string = '';
  public serviceName: string = '';
  public methods: MethodMeta[] = [];
  public events: MethodMeta[] = [];

  public validate(obj: { [key: string]: any }) {
    const missingMethods = this.methods.map((m) => m.property).filter((f) => typeof obj[f] !== 'function');

    if (missingMethods.length) {
      throw new Error(getMetaMissingFunctionsErrorMsg(this.serviceName, obj.constructor.name, missingMethods));
    }
  }
}
